
import React, {useState, useEffect, useMemo } from "react";
import { useSelector } from "react-redux";
import {getSymbolList, getGoogleSheet, getSectorRotationByRanked, getDeliveryPercentList, getPastDate, getLeadingSectors} from "../action/api-services";
import StockAction from "../component/stockAction";
import moment from "moment";
import {useDispatch} from "react-redux";
import PageLoader from "../component/loader";
import DeliveryGraph from "../component/deliveryGraph";
import {AIPromptForStock1, NSE_filter_marketcap, todayMarketHoldTime} from "../utils/constants";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { setDeliveryDataReducer } from "../redux/slice/deliveryData";
import { useNavigate } from "react-router-dom";
import StockStrength from "../component/stockStrength";
import SectorPanchang from "../component/sectorPanchag";
import { getSwingSetup, isFarFromEMA20 } from "../utils/utilsFunctions";




const DeliveryPage = () => {
    const dispatch = useDispatch();
    const [loader, setLoader] = useState(false);
    const [deliveryByDateDataBase, setDeliveryByDateDataBase] = useState([]);
    const [getSectorsList, setSectorsList] = useState([]);
    const [series, setSeries] = useState('EQ');
    const [searchText, setSearchText] = useState('');
    const [searchFilterData, setSearchFilterData] = useState([]);
    const [trendSector, setTrendSector] = useState("select");
    const [todaysetupStatus, setTodaysetupStatus] = useState([]);
    const [deliverySectorData, setDeliverySectorData] = useState([]);
    
    const [pastDate, setPastDate] = useState([]);
    const [todayTime, setTodayTime] = useState([]);
    const [todayData, setTodayData] = useState([]);
    const [symbolData, setSymbolData] = useState([]);
    const [sectorData, setSectorData] = useState([]);

    const deliveryDataList = useSelector((state) => state.deliveryData.value);
    const NSE_Past_date = useSelector((state) => state.pastDate.value);
    const [getMaxDate, setMaxDate] = useState(moment(NSE_Past_date[0]?.max_date).format('YYYY-MM-DD'));
    const [startDate, setStartDate] = useState(moment(NSE_Past_date[0]?.max_date).format('YYYY-MM-DD'));
    // const [startDate, setStartDate] = useState(new Date());
    const userToken = useSelector((state) => state.userToken.value);
    const navigate = useNavigate();


    const currentDate = moment(startDate).format('YYYY-MM-DD') > moment(NSE_Past_date[0]?.max_date).format('YYYY-MM-DD')? moment(NSE_Past_date[0]?.max_date).format('YYYY-MM-DD') : moment(startDate).format('YYYY-MM-DD');
    // moment(startDate).format('YYYY-MM-DD');

    const isWeekdayAllowed = (date) => {
        const day = date.getDay();    
        date.setDate(date.getDate() - 1);        
        const excludeDate = date.toISOString().split("T")[0];
        
        
        return day !== 0 && day !== 6; // Exclude weekends and holidays
        // return day !== 0 && day !== 6 && !YearHolidays.includes(excludeDate);
      };

    


    useEffect(() => {  
        if(userToken){
            let current_date = moment(currentDate).format('DDMMYY');
            setLoader(true)
            // dispatch(setDeliveryDateReducer(startDate));

                    Promise.all([
                              getPastDate(userToken),
                              getGoogleSheet("", userToken),
                              getSymbolList(series, '', userToken),
                              getDeliveryPercentList(current_date, 'symbols', '', '', series, '', userToken),
                            //   getSectorRotationByRanked({date: moment(currentDate).format('YYYY-MM-DD'), type : ''}, userToken)
                              getLeadingSectors(userToken)
                            ])
                            .then(([pastDate, googleRes, symbolRes, delivery, indices]) => {
                              setPastDate(pastDate?.data.data[0].max_date)
                              setTodayTime(googleRes.data.data.datetime);
                              setTodayData(googleRes.data.data.json_data);
                              setSymbolData(symbolRes.data.data);
                              setDeliveryByDateDataBase(delivery.data.data);
                              dispatch(setDeliveryDataReducer(delivery.data.data || []));
                              setSectorsList(indices.data.week || []);
                              setDeliverySectorData([]);
                              setTrendSector("Select");
                            })
                            .catch(console.error)
                            .finally(() => setLoader(false));
                    } else {
                            navigate(`/`);
                    }


    }, [startDate, userToken]);

    
    useEffect(() => {
            if (!deliveryByDateDataBase || !symbolData || !todayData) {
                return [];
            }
            const marketCap = series === "ETF" ? 0 : NSE_filter_marketcap;
            const symbolMap = new Map(
                symbolData
                    .filter(item =>
                        item.active === "1" &&
                        item.series === series &&
                        Number(item.MarketCap) >= marketCap
                    )
                    .map(item => [item.symbol, item])
            );

            const todayMap = new Map(
                todayData.map(item => [item.TICKER, item])
            );

            


            const grouped = {
                isFarEMA20: [],
                isIncreasingScore: [],
                isIncreasingDelivery: [],
                isIncreasingVolume: [],
                isInstitutionalBuying: [],
                isBTST:[],
                isMomentum:[],
                isHotStars:[]
            };

            const sectorMap = new Map();

            deliveryByDateDataBase.forEach(item => {

                const details = symbolMap.get(item.symbol);
               

                if (!details || !item.stock_data || item.stock_data.length < 4) {
                    return;
                }



                const sector = details?.group_sector;

                if (!sector) return;

                const chnPer = Number(item.stock_data?.[0]?.chn_per || 0);
                const currentStar = Number(item.stock_data?.[0]?.current_star || 0);

                if (!sectorMap.has(sector)) {
                    sectorMap.set(sector, {
                        sector,
                        total_count: 0,
                        star_count: 0,
                        move_count: 0,
                        symbols: []
                    });
                }

                const data = sectorMap.get(sector);

                data.total_count += 1;

                if (currentStar === 1) {
                    data.star_count += 1;
                }

                if (chnPer > 0) {
                    data.move_count += 1;
                }

                data.symbols.push({
                    symbol: item.symbol,
                    chn_per: chnPer,
                    current_star: currentStar
                });






                const stockData = [...item.stock_data].reverse();

                const avgVolume = stockData.reduce((sum, d) => sum + Number(d.ttl_trd_qty), 0) / stockData.length;

                const avgTrades = stockData.reduce((sum, d) => sum + Number(d.no_of_trades), 0) / stockData.length;              

                const todayLTP = todayMap.get(item.symbol) || null;

                const hight52 = ((details?.high52w - todayLTP.LTP) * 100)/todayLTP.LTP;

                const todayData = todayLTP ? {
                        open_price      : todayLTP.OPEN,
                        high_price      : todayLTP.HIGH,
                        low_price       : todayLTP.LOW,
                        close_price     : todayLTP.LTP,
                        chn_per         : todayLTP.CHANGEPER,
                        ttl_trd_qty     : todayLTP.VOLUME,
                        delivery_date   : moment(todayLTP.DATETIME).format('YYYY-MM-DD')
                    }
                    : null;

                const obj = {
                    ...item,
                    details,
                    todayLTP: todayLTP
                };

                

                // -------------------------
                // Increasing Score
                // -------------------------
                const isIncreasingScore = stockData.every((d, i, arr) =>
                    i === 0 || Number(d.score) > Number(arr[i - 1].score)
                );

                if (item.score > 55 && isIncreasingScore && Number(details.hotStar) === 1 && Number(item.ATR_PER) > 3) {
                    grouped.isIncreasingScore.push(obj);
                }

                // -------------------------
                // Far From EMA20
                // -------------------------
                const emaDistance =
                    isFarFromEMA20(item.stock_data[0].close_price, item.EMA20).ema_distance;
                    // console.log("stockData[0].ATR_PER > stockData[item.stockData.length - 1].ATR_PER &&", stockData[0].ATR_PER,  stockData[stockData.length - 1].ATR_PER)

                if (
                    emaDistance > 3 &&
                    emaDistance <= 15 &&
                    item.score > 70 &&
                    Number(item.trueAvgVolume) === 1 &&
                    Number(item.EMA20) > Number(item.SMA20)
                ) {
                    grouped.isFarEMA20.push(obj);
                }

                // -------------------------
                // Increasing Delivery
                // -------------------------
                const isIncreasingDelivery = stockData.every((d, i, arr) =>
                    i === 0 ||
                    Number(d.delivery_per) > Number(arr[i - 1].delivery_per)
                );

                if (
                    isIncreasingDelivery &&
                    Number(item.trueAvgVolume) === 1 &&
                    Number(item.angle10) > 5 &&
                    stockData[stockData.length - 1].close_price > stockData[0].close_price
                ) {
                    grouped.isIncreasingDelivery.push(obj);
                }

                // -------------------------
                // Increasing Volume
                // -------------------------
                const isIncreasingVolume = stockData.every((d, i, arr) =>
                    i === 0 ||
                    Number(d.ttl_trd_qty) > Number(arr[i - 1].ttl_trd_qty)
                );

                if (
                    isIncreasingVolume &&
                    Number(item.trueAvgVolume) === 1 &&
                    Number(item.angle10) > 5 &&
                    stockData[stockData.length - 1].close_price > stockData[0].close_price
                ) {
                    grouped.isIncreasingVolume.push(obj);
                }

                // -------------------------
                // Institutional Buying
                // -------------------------
                const matchedDays = stockData.filter(day =>
                    Number(day.ttl_trd_qty) > avgVolume &&
                    Number(day.no_of_trades) < avgTrades
                ).length;

                if (
                    matchedDays >= 3 &&
                    Number(item.angle10) > 5 &&
                    item.score > 50
                ) {
                    grouped.isInstitutionalBuying.push(obj);
                }
                
                

                // For BTST
                const is_today = moment(pastDate).isSame(moment(item.stock_data[0].delivery_date), 'day'); // moment(pastDate).isSame(moment(), 'day');
                
                const today = is_today? todayData : item.stock_data[0];
                const prevDay = is_today? item.stock_data[0] : item.stock_data[1];

                const prevDayClose = Number(prevDay.close_price);
                const todayOpen = Number(today.open_price);
                const todayLow = Number(today.low_price);
                const todayClose = Number(today.close_price);

                const todayDownPer = ((todayOpen - todayLow) / todayOpen) * 100;
                const recoveryPer = ((todayClose - todayLow) / (todayOpen - todayLow)) * 100;
                const delivery = item.stock_data[0].delivery_per;

                if(
                    Number(item.score) > 60 &&
                    Number(item.trueAvgVolume) === 1 &&
                    todayLow > prevDayClose &&
                    todayOpen > todayLow &&
                    todayClose > todayOpen &&
                    // todayDownPer > 2 && 
                    Number(details.hotStar) === 1 &&
                    Number(today.ttl_trd_qty) > Number(prevDay.ttl_trd_qty) &&
                    Number(item.angle20) > 20 && Number(item.angle5) > 10  && 
                    parseFloat(item.SMA50) >  parseFloat(item.SMA200) && 
                    Math.abs(Number(emaDistance)) <= 15 &&
                    Number(item.ATR_PER) > 2 &&
                    
                    // Number(delivery) > 30 &&
                    recoveryPer >= 60
                    
                ){
                    // console.log("BTST", item.symbol, today);
                     grouped.isBTST.push(obj);
                }

                // For Momentum //isMomentum
                const momentumCounts = item.stock_data.slice(0, 5)
                    .reduce((count, day) => {
                        const type = day.momentum_type;

                        if (type === "STRONG") count.STRONG++;
                        else if (type === "UPCOMING") count.UPCOMING++;
                        else if (type === "BUILDING") count.BUILDING++;

                        return count;
                        },
                        {
                        STRONG: 0,
                        UPCOMING: 0,
                        BUILDING: 0,
                        }
                    );


                const setup = getSwingSetup(item);
                if (setup.eligible && setup.setup === 'STRONG_SWING' && setup.swingScore > 60 ) {
                    grouped.isMomentum.push(obj);
                }


                // isHotStars
                const isCurrentStars = stockData.filter(d => Number(d.current_star) === 1).length;

                
                if(
                    todayClose > 80
                    // && isCurrentStars > 2 
                    && Number(item.current_star) === 1 
                     
                    // && Number(details.hotStar) === 1 
                    && Number(item.ATR_PER) > 2
                    && Number(hight52) < 20 
                    && Math.abs(Number(emaDistance)) <= 15
                ){
                    // console.log(">>>", isCurrentStars);
                    grouped.isHotStars.push(obj);
                }







            });


            setTodaysetupStatus(grouped);  

            const uniqueSectors = [...sectorMap.values()]
            .map(item => ({
                ...item,
                move_per: item.total_count > 0
                    ? (item.move_count / item.total_count) * 100
                    : 0
            }))
            .sort((a, b) =>
                b.star_count - a.star_count ||
                b.move_per - a.move_per
                // b.move_count - a.move_count
            );
            

            setSectorData(uniqueSectors);

               
            
    }, [deliveryByDateDataBase, symbolData, todayData, series]);


    // console.log(todaysetupStatus)

    const scrollToSection = (hashID) => {
        const element = document.getElementById(hashID);
        if (element) {
            element.scrollIntoView({
            behavior: "smooth",
            block: "start",
            });
        }
    };


    const handleSearch = (e) => {
        setSearchText(e);

        if (!deliveryByDateDataBase || !symbolData || !todayData) {
            setSearchFilterData([]);
            return;
        }

        if (e.trim().length > 2) {
            // Create lookup maps
            const symbolMap = new Map(symbolData.map(item => [item.symbol, item]));
            const todayMap = new Map(todayData.map(item => [item.TICKER, item]));

            const filteredData = deliveryByDateDataBase
                .filter(item =>
                    item.symbol?.toUpperCase().includes(e.trim().toUpperCase())
                )
                .map(item => ({
                    ...item,
                    details: symbolMap.get(item.symbol) || null,
                    todayLTP: todayMap.get(item.symbol) || null,
                }));

            setSearchFilterData(filteredData);
        } else {
            setSearchFilterData([]);
        }
    };   

    const changeTrendSectorHandler = (sector) => {
        setTrendSector(sector);
        let current_date = moment(currentDate).format('DDMMYY');
        getDeliveryPercentList(current_date, 'sectors', sector, '', 'EQ', 7, userToken)
                      .then(res => {
                        scrollToSection('Sector');

                        const dataList = Object.values(res?.data?.data || {});

                        const marketCap = series === "ETF" ? 0 : NSE_filter_marketcap;
                        const symbolMap = new Map(
                            symbolData
                                .filter(item =>
                                    item.active === "1" &&
                                    item.series === series &&
                                    Number(item.MarketCap) >= marketCap
                                )
                                .map(item => [item.symbol, item])
                        );
                        const todayMap = new Map(
                            todayData.map(item => [item.TICKER, item])
                        );
                       

                        const result = dataList.reduce((list, item) => {
                                    const todayLTP = todayMap.get(item.symbol) || null;
                                    const details = symbolMap.get(item.symbol);

                                    if (!details || !item?.stock_data || item.stock_data.length < 6) {
                                        return list;
                                    }

                                    const stockData = [...item.stock_data].reverse();
                                    // const firstWeekData = item.stock_data.slice(0, 5);


                                    const avgVolume = stockData.reduce((sum, d) => sum + Number(d.ttl_trd_qty || 0), 0) / stockData.length;

                                    const avgTrades = stockData.reduce((sum, d) => sum + Number(d.no_of_trades || 0), 0) / stockData.length;

                                    const scoreCount = stockData.filter((stock) => Number(stock.score) > 50 ).length;
                                    const changePerCount = stockData.filter((stock) => Number(stock.chn_per) > 0 ).length;

                              
                                    const currPrice =  parseFloat(item.stock_data[0].close_price);
                                    const lastPrice =  parseFloat(item.stock_data[5].close_price);


                                    const emaDistance =  isFarFromEMA20(currPrice, item.EMA20).ema_distance;

                                    const growthPer =  (currPrice - lastPrice) * 100 / lastPrice;
                                    


                                    const obj = {
                                        ...item,
                                        details,
                                        todayLTP: todayLTP,
                                        emaDistance: emaDistance,
                                        growthPer: growthPer
                                        // avgVolume,
                                        // avgTrades,
                                        // scoreCount,
                                    };

                                    
                                    list.sectorGeneral.push(obj);

                                    const isUpcoming =
                                            // parseFloat(item.score) >= 55 &&
                                            parseFloat(item.angle5) >= 2 &&
                                            scoreCount >= Math.ceil(stockData.length * 0.4) &&
                                            growthPer >= 2 &&
                                            // growthPer <= 10 &&
                                            // Math.abs(emaDistance) <= 3 &&
                                            stockData[0].ATR_PER > stockData[stockData.length - 1].ATR_PER &&
                                            changePerCount > 3 &&
                                            parseInt(item.trueAvgVolume, 10) === 1;

                                    if (isUpcoming) {
                                        list.sectorRotation.push(obj);
                                    }

                                    return list;
                                }, {
                                    sectorRotation: [],
                                    sectorGeneral: [],
                                });

                                // result.sort((a, b) => Number(b.angle10) - Number(a.angle10));
                                result.sectorRotation.sort((a, b) => Number(b.growthPer) - Number(a.growthPer));
                                result.sectorGeneral.sort((a, b) => Number(b.growthPer) - Number(a.growthPer));
                                setDeliverySectorData(result);
                                
        })
        .catch(console.error);
    }

    const recordsDisplay = (seq, lable, data, hashID) =>{
       return (
        <>
            <tr key={`row_trendSector_tr_${seq}`} id={hashID}><td colSpan={24} style={{fontSize:"14px", fontWeight:'500', paddingTop:'10px', paddingBottom: '2px', backgroundColor:'#F0F0F0', textAlign:'left'}}>{lable} [{data.length}]</td></tr>
            {data?.map((obj, index) => {
                let symbolName = obj.symbol;
                
                let deliverylist = Object.values(deliveryDataList);
                let deliveryData = deliverylist?.find((s) => s.symbol === symbolName);
                let EMA21Cross = parseFloat(deliveryData?.EMA20) > parseFloat(deliveryData?.SMA20);                        
                
                
                let high52w = obj.details?.high52w? obj.details?.high52w: 0;
                let low52w = obj.details?.low52w? obj.details?.low52w: 0;
                let highDate = obj.details?.highDate? moment(obj.details?.highDate).format("DD-MM-YY"): "";
                let lowDate = obj.details?.lowDate? moment(obj.details?.lowDate).format("DD-MM-YY"): "";
                let Structure = obj?.structure_json;

                let is_today = moment(pastDate).isSame(moment(obj.stock_data[0].delivery_date), 'day');
                let lastDateObj = is_today? obj.stock_data[4]: obj.stock_data[0];

                let emaDistance =  isFarFromEMA20(obj.todayLTP.LTP, obj.EMA20).ema_distance;

                
                // let tchn_per = ((obj.todayLTP?.LTP - lastDateObj.close_price) * 100) / lastDateObj.close_price;
                let tchn_per = ((obj.stock_data[0].close_price - obj.stock_data[4].close_price) * 100) / obj.stock_data[4].close_price;
                
                let high52wPer = (((high52w - obj.todayLTP.LTP) * 100) / high52w);

                let Volume = parseInt((moment(todayTime).isSame(obj.todayLTP?.DATE, 'day')) && todayMarketHoldTime() === true? obj.todayLTP?.VOLUME: obj.stock_data?.[0]?.ttl_trd_qty);
                let Prev_Volume = parseInt((moment(todayTime).isSame(obj.todayLTP?.DATE, 'day')) && todayMarketHoldTime() === true? obj.stock_data[0].ttl_trd_qty:obj.stock_data[1]?.ttl_trd_qty);

                
                let cuurVolPer = ((Volume - Prev_Volume) * 100) / Prev_Volume;

                let prevDeliv = obj.stock_data[1]?.delivery_per;
                let deliv = obj.stock_data[0].delivery_per;

                
            return (
                    <tr
                        className={`tr_${obj.details.id}`}
                        key={`row_item_${obj.details.id}_${index}`}
                        id={`row_item_${obj.details.id}_${index}`}
                        >
                        <td 
                            className={`symbolName ${obj.in_portfolio === '1' && obj.is_triggered ===''? 'inpotfolio':''}`} 
                            style={{borderLeft: obj.reject_stock === '1' ? '3px solid #f00' : obj.verified === '1'? "3px solid #FF9800" : '', background: obj.reject_stock === '1' ? '#ffc3c3' : obj.today_occurred === moment().format('YYYY-MM-DD') && obj.occurance > 2? '#d3ffd5':''}}
                            title={(obj.today_occurred === moment().format('YYYY-MM-DD') && obj.occurance > 2? `[Occurance ${obj.occurance}]` : '')  +  (obj.in_portfolio === '1' && obj.is_triggered ===''? `Bought at: ${ moment(obj.portfolio_buy_date).format('DD-MM-YYYY')} - ${obj.portfolio_buy_price} [${obj.unit_qty}] ${obj.demat}` :  '')}
                        >
                            {symbolName}{" "}
                            {obj.details?.hotStar === "1" ? (
                            <span className="hotStar"></span>
                            ) : null}
                            {obj.current_star === "1" ? (
                            <span className="currStar"></span>
                            ) : null}
                        </td>
                        <td>
                            <StockAction
                            symbol={symbolName}
                            delivery={false}
                            currentPrice={obj.stock_data[0].close_price}
                            deliveryPer={obj.stock_data[0].delivery_per}
                            hotStar={obj.details?.hotStar}
                            myFev={obj.details?.myFev}
                            eventName={"Delivery"}
                            slPrice={obj.stock_data[0].close_price * 0.97}
                            gttPrice={obj.stock_data[0].close_price * 1.03}
                            rowId={`row_item_${obj.details.id}_${index}`}
                            score={obj.score}
                            />
                        </td>
                        <td>
                            <DeliveryGraph
                            symbol={symbolName}
                            todayLTP={obj.todayLTP}
                            date={startDate}
                            />
                        </td>
                        <td title={obj.score} style={{ textAlign: "right", background: obj.score > 70 ? "#72d083": obj.score > 60 ? "#ffec9c": "" }}>
                            {obj.score}
                        </td>
                        <StockStrength
                            id={`del_${obj.id}`}
                            selectedDate={startDate}
                            symbol={symbolName}
                            todayLTP={obj.todayLTP}
                            details={obj.details}
                            // predictions={obj.prediction}
                        />
                        <SectorPanchang
                            symbol={symbolName}
                            sector={obj.details?.group_sector}
                            todayData={todayData}
                            symbolData={symbolData}
                            tag = "td"
                            align = "right"
                            durationDays = ""
                        />
                        
                        <td className="indices" style={{ textAlign: "left" }}>
                            {(() => {
                            const label = obj.details?.nifty50
                                ? "50"
                                : obj.details?.nifty100
                                ? "100"
                                : obj.details?.nifty200
                                ? "200"
                                : obj.details?.nifty500
                                ? "500"
                                : obj.details?.totalMarket
                                ? "TM"
                                : "";
                            const excludedSeries = ["ETF", "BOND", "MF"];
                            const showFev =
                                obj.details?.myFev &&
                                !excludedSeries.includes(obj.details?.series);
                            return (
                                label +
                                (showFev ? `${label ? ", " : ""}Fev` : "")
                            );
                            })()}
                        </td>
                        <td title={`If CHOCH true | lastHigh: ${Structure.lastHigh} | lastLow: ${Structure.lastLow} | prevHigh: ${Structure.prevHigh} | prevLow: ${Structure.prevLow}`}
                            style={{
                                fontSize:'0.67rem',  
                                textAlign: "left",
                                backgroundColor: Structure.choch === true && Structure.slope > 1? '#9ce49c': ''
                            }}
                        
                        >{`${Structure.structure}`}</td>
                        <td style={{textAlign:'left'}} title={obj.stock_data[0].momentum_type}>{obj.stock_data[0].momentum_type?.charAt(0)}</td>
                        <td>{obj.stock_data[0].close_price}</td>
                        <td title={`${obj.todayLTP?.OPEN} | ${obj.todayLTP?.HIGH} | ${obj.todayLTP?.LOW}`}>{obj.todayLTP?.LTP}</td>
                        <td
                            style={{
                                color:
                                parseFloat(obj.todayLTP?.CHANGEPER) > 0
                                    ? "#1c8b16"
                                    : "#f00",
                            }}
                            >
                            {obj.todayLTP?.CHANGEPER}%
                        </td>
                        <td style={{
                                color:
                                parseFloat(tchn_per) > 0
                                    ? "#1c8b16" 
                                    : parseFloat(tchn_per) === 0
                                    ? "#999" : "#f00",
                            }}
                        >
                                {parseFloat(tchn_per).toFixed(2)}
                        </td>
                        <td
                            style={{
                                textAlign: "right",
                                background: Math.abs(Number(emaDistance)) <= 12? "#e2ffe5":""
                            }}
                            >
                            {emaDistance}
                        </td>
                        <td
                            style={{
                                textAlign: "right",
                                background: EMA21Cross === true? "#e2ffe5":""
                            }}
                            title={`EMA20 > SMA20: ${obj.SMA20}`}
                            >
                            {obj.EMA20}
                        </td>
                        <td
                            style={{
                                textAlign: "right",
                                background:
                                parseFloat(obj.SMA20) >
                                parseFloat(obj.SMA50)
                                    ? "#e2ffe5"
                                    : "#fff8f8",
                            }}
                            title={`SMA20: ${obj.SMA20}`}
                            >
                            {obj.SMA50}
                            </td>
                        <td title={`${high52w} | ${highDate}`} 
                            style={{background:high52wPer >= 8 && high52wPer <=40 ? "" : "#fff6f6"}}>
                            {high52wPer.toFixed(2) + "%"}
                            </td>
                            <td title={`${lowDate} | ${highDate}`}>{`${low52w} | ${high52w}`}</td>
                            <td title={`${cuurVolPer.toFixed(2)}%` }
                                style={{background: cuurVolPer > 25 ? "#e2ffe5" : ""}}
                            >
                            {Number(Prev_Volume).toLocaleString("en-IN")}
                            </td>
                            <td title={deliv > prevDeliv? `${prevDeliv}%`:''}
                            style={{background: deliv > prevDeliv? "#e2ffe5": ""}}
                            > 
                            {deliv}</td>
                            <td style={{ textAlign: "center", padding:"0px"}}>
                            <a
                            title="News"
                            className="newsicon"
                            href={`https://www.google.com/ai?q=${AIPromptForStock1(symbolName)}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            ></a>
                            </td>
                    </tr>
                    )
            })
            }
        </>
       )
    }


    return(
            <React.Fragment>
                <div className="pageContainer">
                  <div className="container-fluid actionControler pb-3">
                    <div className="row"><div className="col-12 pb-1">
                        <strong>938179</strong> | 
                        Leader: {getSectorsList?.leaders?.join(', ')}  | 
                        Upcoming: {getSectorsList?.upcoming?.join(', ')} 
                        {`${getSectorsList?.newArrivals?.length > 0  ? 
                        ` | New Arrivals: ${getSectorsList.newArrivals.join(", ")}`  : "" }`}
                      </div></div>
                    <div className="row">
                      
                     
                      <div className="col-md-2 col-sm-6 pe-md-0 mb-2 mb-md-0">
                        <div className="form-floating">
                          <input
                            type="text"
                            className="form-control"
                            id="symbolSearch"
                            placeholder="Search"
                            onKeyUp={(e) => handleSearch(e.target.value)}
                          />
                          <label htmlFor="symbolSearch">Search</label>
                        </div>
                      </div>              
        
                      <div className="col-md-2 col-sm-6 pe-md-0 mb-2 mb-md-0">
                            <div className='form-floating'>
                                <DatePicker 
                                    placeholderText={'Select date'}
                                    className="form-control"
                                    id="viewDate"
                                    selected={startDate} 
                                    onChange={(date) => setStartDate(date)}
                                    dateFormat="dd/MM/YYYY"
                                    minDate={moment().subtract(15, "days")}
                                    maxDate={getMaxDate}
                                    filterDate={isWeekdayAllowed}
                                />
                                <label className='show' htmlFor="viewDate">Date</label>
                            </div>
                      </div>
        
                      <div className="col-md-2 col-sm-6 mb-2 mb-md-0 pe-md-0">
                        <div className="form-floating">
                          <select
                            className="form-control"
                            id="trendSector"
                            value={trendSector}
                            onChange={e => changeTrendSectorHandler(e.target.value)}
                          > <option>Select</option>
                                                        
                            {sectorData?.map((item, index) => (
                                <option key={index} value={item.sector}>
                                    {item.star_count > 0 ? item.star_count: '\u00A0\u00A0'} {item.sector}  [{item.total_count}] | {Math.round(item.move_per)}%
                                </option>
                            ))}
                           
                          </select>
                          <label htmlFor="trendSector">Sector</label>
                        </div>
                      </div>                      
                     
        
                    </div>

                    <div className="mt-3 pagewrap" style={{paddingBottom: '50px'}}>
                        {loader === true? (
                            <PageLoader />
                            ) : (
                            <table className="increaseOI table-responsive">
                                                <thead>
                                                <tr key={`item_0`}>
                                                    <th style={{ width: "150px" }}>Symbol</th>
                                                    <th style={{ width: "15px" }}></th>
                                                    <th style={{ width: "45px" }}></th>
                                                    <th style={{ width: "40px", textAlign: "left"}}>Score</th>
                                                    <th style={{ width: "50px", textAlign: "left"}}>Strength</th>
                                                    <th style={{ width: "150px", textAlign: "left"}}>Sector</th>
                                                    <th style={{ width: "60px", textAlign: "left"}}>Indices</th>
                                                    <th style={{ width: "100px", textAlign: "left"}}>Structure</th>
                                                    <th style={{ width: "15px" }}>M</th>
                                                    <th style={{ width: "70px" }}>Close</th>
                                                    <th style={{ width: "70px" }}>LTP [{moment(todayTime).format("HH:mm")}]</th>
                                                    <th style={{ width: "50px" }}>Chn%</th>
                                                    <th style={{ width: "55px" }}>5D Chn%</th>
                                                    <th style={{ width: "55px" }}>EMA Dist</th>
                                                    <th style={{ width: "55px" }}>EMA20</th>
                                                    <th style={{ width: "55px" }}>SMA50</th>
                                                    <th style={{ width: "70px" }}>Down 52</th>
                                                    <th style={{ width: "110px" }}>52 L/H</th>
                                                    <th style={{ width: "100px" }}>Vol</th>
                                                    <th style={{ width: "48px" }}>Del%</th>
                                                    <th style={{ width: "60px" }}>News</th>
                                                </tr>
                                                </thead>
                                                <tbody>

                                                    { searchText.length === 0 && deliverySectorData?.sectorGeneral?.length > 0 && recordsDisplay(11, "Sector's Stocks", deliverySectorData?.sectorGeneral, 'sectorGeneral')}

                                                    { searchText.length === 0 && todaysetupStatus?.isMomentum?.length > 0 && recordsDisplay(14, 'Momentum Stocks', todaysetupStatus?.isMomentum, 'Momentum')}

                                                    { searchText.length === 0 && todaysetupStatus?.isBTST?.length > 0 && recordsDisplay(12, 'BTST Stocks', todaysetupStatus?.isBTST, 'BTST')}

                                                    { searchText.length > 0 && searchFilterData?.length > 0 && recordsDisplay(101, 'Search', searchFilterData, 'searchFilterData')}
                                                    
                                                    { searchText.length === 0 && todaysetupStatus?.isIncreasingVolume?.length > 0 && recordsDisplay(4, 'Increasing Volume', todaysetupStatus?.isIncreasingVolume, 'IncreasingVolume')}

                                                    { searchText.length === 0 && todaysetupStatus?.isInstitutionalBuying?.length > 0 && recordsDisplay(5, 'Institutional Buying', todaysetupStatus?.isInstitutionalBuying, 'InstitutionalBuying')}

                                                    { searchText.length === 0 && todaysetupStatus?.isIncreasingDelivery?.length > 0 && recordsDisplay(3, 'Increasing Delivery', todaysetupStatus?.isIncreasingDelivery, 'IncreasingDelivery')}

                                                    { searchText.length === 0 && todaysetupStatus?.isIncreasingScore?.length > 0 && recordsDisplay(1, 'Increasing Score', todaysetupStatus?.isIncreasingScore, 'IncreasingScore')}

                                                    {/* { searchText.length === 0 && todaysetupStatus?.isFarEMA20?.length > 0 && recordsDisplay(2, 'Far from EMA20', todaysetupStatus?.isFarEMA20, 'FarfromEMA20')} */}

                                                    { searchText.length === 0 && deliverySectorData?.sectorRotation?.length > 0 && recordsDisplay(10, 'Gromming Stocks', deliverySectorData?.sectorRotation, 'GrommingSector')}

                                                    

                                                    { searchText.length === 0 && todaysetupStatus?.isHotStars?.length > 0 && recordsDisplay(14, "Todays's Stars", todaysetupStatus?.isHotStars, 'isHotStars')}

                                                    

                                                   

                                                    

                                                

                                                </tbody>
                            </table>
                        )}
                    </div>
                  </div>
                </div>
            </React.Fragment>

    )


}
export default DeliveryPage;